/* ==========================================================================
   Alchemica landing page — behaviour
   Plain JavaScript. No React, no build step, no dependencies.

   WHERE TO EDIT YOUR PRODUCT COPY:
   Scroll to the PRODUCTS block just below. Each flavour has its headline,
   description, nutrition table and ingredient list. Change the text between
   the quote marks and save. Do not remove the quote marks or commas.
   ========================================================================== */

(function () {
  'use strict';

  /* ======================================================================
     PRODUCTS — your editable copy
     ====================================================================== */

  var ORDER = ['glow', 'defence', 'clarity', 'gutflora', 'cleanse'];

  var PRODUCTS = {
    glow: {
      name: 'Glow',
      fullName: 'Glow — Hair, Skin & Nails',
      headline: 'Eat Your Skincare!',
      desc: 'Marine collagen peptides, CoQ10 and resveratrol alongside eleven vitamins and minerals. Biotin and zinc contribute to the maintenance of normal hair, skin and nails.',
      longDesc: 'Glow brings together marine collagen peptides, collagen amino acids, beta-alanine, coenzyme Q10 and resveratrol with a full spread of vitamins and minerals. Vitamin C contributes to normal collagen formation for the normal function of skin; biotin and zinc contribute to the maintenance of normal hair, skin and nails; selenium contributes to the maintenance of normal hair and nails. Two mango flavoured gummies per serving, sugar-free and made with plant-based pectin.',
      flavour: 'Mango',
      img: 'bottle-glow',
      alt: 'Alchemica Glow gummies jar in golden light',
      campaign: 'glow-model',
      campaignAlt: 'Model holding the Glow jar in ethereal silver jewellery',
      vars: { ac: '#FFD34D', acDeep: '#7A4500', halo: 'rgba(255,214,110,.6)', glow: 'rgba(255,158,10,.5)', ink: '#3A2503', inkSoft: 'rgba(58,37,3,.76)', glass: 'rgba(255,255,255,.3)', glassBrd: 'rgba(255,255,255,.6)', card: 'rgba(255,255,255,.28)', card2: 'rgba(255,255,255,.38)', cardBrd: 'rgba(122,69,0,.22)', chip: 'rgba(255,255,255,.32)', chipBrd: 'rgba(122,69,0,.3)', btnFg: '#FFFDF6', btnBg: '#7A4500', footer: 'rgba(255,255,255,.26)', acLight: '#B97416', darkInk: true },
      nutrition: [
        { k: 'Marine Collagen Peptides', v: '5,000 mg', nrv: '—' },
        { k: 'Beta-Alanine', v: '10 g', nrv: '—' },
        { k: 'Coenzyme Q10', v: '100 mg', nrv: '—' },
        { k: 'Resveratrol', v: '100 mg', nrv: '—' },
        { k: 'Vitamin C', v: '40 mg', nrv: '50%' }
      ],
      // Descriptive only — composition and form. No health or nutrition claims.
      ingredients: [
        { glyph: '✦', name: 'Marine Collagen Peptides', dose: '5,000 mg', sci: 'Hydrolysed collagen peptides of marine origin, supplying type I and type III collagen fragments.', art: 'ing-collagen' },
        { glyph: '◈', name: 'Collagen amino acids', dose: '3 actives', sci: 'The three amino acids most abundant in collagen protein, included alongside the peptides: glycine 50 mg, proline 20 mg and hydroxyproline 20 mg.', art: 'ing-aminos' },
        { glyph: '❖', name: 'Beta-Alanine', dose: '10 g', sci: 'A naturally occurring beta-amino acid and a precursor in carnosine synthesis.', art: 'ing-betaalanine' },
        { glyph: '☀', name: 'Coenzyme Q10', dose: '100 mg', sci: 'A fat-soluble quinone found in cell membranes, supplied here in its ubiquinone form.', art: 'ing-coq10' },
        { glyph: '✧', name: 'Resveratrol', dose: '100 mg', sci: 'A stilbenoid polyphenol occurring naturally in grape skin and Japanese knotweed.', art: 'ing-resveratrol' },
        { glyph: '☉', name: 'Antioxidant vitamins', dose: '3 actives', sci: 'Vitamin C (ascorbic acid) 40 mg, vitamin E 12 mg and vitamin A as beta-carotene 800 µg RAE. Vitamin C contributes to normal collagen formation for the normal function of skin. Vitamin E contributes to the protection of cells from oxidative stress. Vitamin A contributes to the maintenance of normal skin.', art: 'ing-antioxidant' },
        { glyph: '✚', name: 'Vitamin D3', dose: '20 µg', sci: 'Cholecalciferol, the form of vitamin D synthesised in skin exposed to sunlight. Vitamin D contributes to the normal function of the immune system and to the maintenance of normal bones and muscle function.', art: 'ing-d3' },
        { glyph: '⟡', name: 'B vitamins', dose: '4 actives', sci: 'Biotin (B7) 100 µg, niacin (B3) 16 mg, vitamin B6 1.4 mg and vitamin B12 2.5 µg. Biotin contributes to the maintenance of normal hair and skin. Niacin contributes to the maintenance of normal skin. Vitamins B6 and B12 contribute to the reduction of tiredness and fatigue.', art: 'ing-bvitamins' },
        { glyph: '◍', name: 'Trace minerals', dose: '3 actives', sci: 'Zinc 10 mg, copper 1 mg and selenium 55 µg. Zinc contributes to the maintenance of normal hair, skin and nails. Selenium contributes to the maintenance of normal hair and nails. Copper contributes to the maintenance of normal connective tissues.', art: 'ing-minerals' }
      ],
      fullIngredients: [
        { name: 'Marine Collagen Peptides (Type I & III)', dose: '5,000 mg' },
        { name: 'Glycine', dose: '50 mg' },
        { name: 'Proline', dose: '20 mg' },
        { name: 'Hydroxyproline', dose: '20 mg' },
        { name: 'Beta-Alanine', dose: '10 g' },
        { name: 'Coenzyme Q10 (Ubiquinone)', dose: '100 mg' },
        { name: 'Resveratrol', dose: '100 mg' },
        { name: 'Vitamin C (Ascorbic Acid)', dose: '40 mg' },
        { name: 'Vitamin D3 (Cholecalciferol)', dose: '20 µg' },
        { name: 'Vitamin E', dose: '12 mg' },
        { name: 'Biotin (Vitamin B7)', dose: '100 µg' },
        { name: 'Vitamin A (Beta-Carotene)', dose: '800 µg RAE' },
        { name: 'Zinc', dose: '10 mg' },
        { name: 'Copper', dose: '1 mg' },
        { name: 'Selenium', dose: '55 µg' },
        { name: 'Niacin (Vitamin B3)', dose: '16 mg' },
        { name: 'Vitamin B6', dose: '1.4 mg' },
        { name: 'Vitamin B12', dose: '2.5 µg' }
      ]
    },

    defence: {
      name: 'Defence',
      fullName: 'Defence — Immune Support',
      headline: 'Armour, but make it cherry.',
      desc: 'Vitamin C, D3, zinc and elderberry in a wild-cherry gummy. Bold protection for immune systems with places to be.',
      longDesc: 'Defence stacks the four most evidenced immune nutrients — vitamin C, vitamin D3, zinc and elderberry extract — at full NRV doses. Armour, in wild-cherry form.',
      flavour: 'Wild Cherry',
      img: 'bottle-glow',
      alt: 'Placeholder — replace with the Defence bottle render',
      campaign: 'placeholder-campaign',
      campaignAlt: 'Placeholder for Defence campaign photography',
      vars: { ac: '#FFA79E', acDeep: '#FFD6CF', halo: 'rgba(255,170,160,.45)', glow: 'rgba(90,5,5,.5)', ink: '#FFF6F4', inkSoft: 'rgba(255,244,241,.82)', glass: 'rgba(255,255,255,.2)', glassBrd: 'rgba(255,255,255,.5)', card: 'rgba(255,255,255,.11)', card2: 'rgba(255,255,255,.16)', cardBrd: 'rgba(255,255,255,.28)', chip: 'rgba(255,255,255,.15)', chipBrd: 'rgba(255,255,255,.4)', btnFg: '#A81B1B', btnBg: '#FFFDF6', footer: 'rgba(80,8,8,.28)', acLight: '#C22626' },
      nutrition: [
        { k: 'Vitamin C', v: '160 mg', nrv: '200%' },
        { k: 'Vitamin D3', v: '20 µg', nrv: '400%' },
        { k: 'Zinc', v: '10 mg', nrv: '100%' },
        { k: 'Elderberry extract', v: '150 mg', nrv: '—' }
      ],
      ingredients: [
        { glyph: '❖', name: 'Vitamin C', dose: '160 mg', sci: 'Supports the normal function of the immune system during and after intense physical exercise.' },
        { glyph: '☉', name: 'Vitamin D3', dose: '20 µg', sci: 'Regulates innate and adaptive immune responses; contributes to normal immune system function.' },
        { glyph: '◈', name: 'Zinc', dose: '10 mg', sci: 'Required for immune cell development and signalling; contributes to normal immune function.' },
        { glyph: '✚', name: 'Elderberry', dose: '150 mg', sci: 'Standardised Sambucus nigra extract, rich in anthocyanins studied for seasonal immune support.' }
      ]
    },

    clarity: {
      name: 'Clarity',
      fullName: 'Clarity — Focus & Cognition',
      headline: 'Main character focus.',
      desc: 'B12, L-theanine, ginkgo and ginseng in a blackcurrant gummy. A clear head, delivered in violet.',
      longDesc: 'Clarity blends vitamin B12 and pantothenic acid — both with authorised claims for mental performance — with L-theanine, ginkgo and ginseng. For deadline days and dream-chasing.',
      flavour: 'Blackcurrant',
      img: 'bottle-glow',
      alt: 'Placeholder — replace with the Clarity bottle render',
      campaign: 'placeholder-campaign',
      campaignAlt: 'Placeholder for Clarity campaign photography',
      vars: { ac: '#D5B6FF', acDeep: '#E9DBFF', halo: 'rgba(215,185,255,.45)', glow: 'rgba(45,15,110,.55)', ink: '#FAF6FF', inkSoft: 'rgba(248,243,255,.82)', glass: 'rgba(255,255,255,.2)', glassBrd: 'rgba(255,255,255,.5)', card: 'rgba(255,255,255,.11)', card2: 'rgba(255,255,255,.16)', cardBrd: 'rgba(255,255,255,.28)', chip: 'rgba(255,255,255,.15)', chipBrd: 'rgba(255,255,255,.4)', btnFg: '#5B2FB0', btnBg: '#FFFDF6', footer: 'rgba(40,16,90,.3)', acLight: '#7141C9' },
      nutrition: [
        { k: 'Vitamin B12', v: '5 µg', nrv: '200%' },
        { k: 'Pantothenic acid', v: '6 mg', nrv: '100%' },
        { k: 'L-Theanine', v: '100 mg', nrv: '—' },
        { k: 'Ginkgo biloba', v: '120 mg', nrv: '—' },
        { k: 'Panax ginseng', v: '80 mg', nrv: '—' }
      ],
      ingredients: [
        { glyph: '☾', name: 'Vitamin B12', dose: '5 µg', sci: 'Contributes to normal psychological function and the reduction of tiredness and fatigue.' },
        { glyph: '✦', name: 'L-Theanine', dose: '100 mg', sci: 'Amino acid from green tea associated with alpha-wave activity — alert calm rather than stimulation.' },
        { glyph: '❋', name: 'Ginkgo Biloba', dose: '120 mg', sci: 'Standardised leaf extract studied for cerebral blood flow and cognitive performance.' },
        { glyph: '✧', name: 'Panax Ginseng', dose: '80 mg', sci: 'Adaptogenic root studied for attention and mental working capacity under load.' }
      ]
    },

    gutflora: {
      name: 'Gut Flora',
      fullName: 'Gut Flora — Pre & Probiotic',
      headline: 'Good things grow within.',
      desc: 'A living probiotic and inulin prebiotic in a green-apple gummy. Your microbiome, treated like the garden it is.',
      longDesc: 'Gut Flora pairs one billion CFU of Bacillus coagulans — a spore-form probiotic that survives stomach acid — with chicory inulin to feed what flourishes. Freshness, cultivated daily.',
      flavour: 'Green Apple',
      img: 'bottle-glow',
      alt: 'Placeholder — replace with the Gut Flora bottle render',
      campaign: 'placeholder-campaign',
      campaignAlt: 'Placeholder for Gut Flora campaign photography',
      vars: { ac: '#A8ECBC', acDeep: '#D6F8E0', halo: 'rgba(185,242,205,.4)', glow: 'rgba(6,60,30,.5)', ink: '#F4FFF7', inkSoft: 'rgba(240,255,246,.82)', glass: 'rgba(255,255,255,.2)', glassBrd: 'rgba(255,255,255,.5)', card: 'rgba(255,255,255,.11)', card2: 'rgba(255,255,255,.16)', cardBrd: 'rgba(255,255,255,.28)', chip: 'rgba(255,255,255,.15)', chipBrd: 'rgba(255,255,255,.4)', btnFg: '#1C7A42', btnBg: '#FFFDF6', footer: 'rgba(6,55,28,.3)', acLight: '#238049' },
      nutrition: [
        { k: 'Bacillus coagulans', v: '1 × 10⁹ CFU', nrv: '—' },
        { k: 'Inulin (chicory)', v: '500 mg', nrv: '—' },
        { k: 'Vitamin B6', v: '1.4 mg', nrv: '100%' },
        { k: 'Calcium', v: '120 mg', nrv: '15%' }
      ],
      ingredients: [
        { glyph: '❀', name: 'Bacillus Coagulans', dose: '1bn CFU', sci: 'Spore-forming probiotic strain that survives gastric transit to colonise the gut — studied for digestive comfort.' },
        { glyph: '✿', name: 'Inulin', dose: '500 mg', sci: 'Chicory-root prebiotic fibre that selectively feeds beneficial bifidobacteria populations.' },
        { glyph: '◈', name: 'Vitamin B6', dose: '1.4 mg', sci: 'Contributes to normal protein and glycogen metabolism and immune function — much of it gut-mediated.' },
        { glyph: '✧', name: 'Calcium', dose: '120 mg', sci: 'Contributes to the normal function of digestive enzymes.' }
      ]
    },

    cleanse: {
      name: 'Cleanse',
      fullName: 'Cleanse — Antioxidant Support',
      headline: 'Unwind. Undo. Renew.',
      desc: 'Vitamin E, selenium and grape-seed extract in a blueberry gummy. A nightly cleanse for cells that had a long day.',
      longDesc: 'Cleanse combines vitamin E, vitamin C and selenium — each with authorised claims for the protection of cells from oxidative stress — with polyphenol-rich grape-seed extract. Take it as the day ends.',
      flavour: 'Blueberry',
      img: 'bottle-glow',
      alt: 'Placeholder — replace with the Cleanse bottle render',
      campaign: 'placeholder-campaign',
      campaignAlt: 'Placeholder for Cleanse campaign photography',
      vars: { ac: '#8FA5FF', acDeep: '#AFC0FF', halo: 'rgba(130,155,255,.35)', glow: 'rgba(20,30,90,.7)', ink: '#EDF0FF', inkSoft: 'rgba(237,240,255,.78)', glass: 'rgba(255,255,255,.12)', glassBrd: 'rgba(190,200,255,.42)', card: 'rgba(255,255,255,.07)', card2: 'rgba(255,255,255,.11)', cardBrd: 'rgba(160,175,255,.24)', chip: 'rgba(159,179,255,.12)', chipBrd: 'rgba(159,179,255,.3)', btnFg: '#16204C', btnBg: '#FFFDF6', footer: 'rgba(5,10,30,.4)', acLight: '#3D5AE8' },
      nutrition: [
        { k: 'Vitamin E', v: '12 mg', nrv: '100%' },
        { k: 'Vitamin C', v: '80 mg', nrv: '100%' },
        { k: 'Selenium', v: '55 µg', nrv: '100%' },
        { k: 'Grape seed extract', v: '100 mg', nrv: '—' }
      ],
      ingredients: [
        { glyph: '☾', name: 'Vitamin E', dose: '12 mg', sci: 'The body’s primary lipid-phase antioxidant; contributes to the protection of cells from oxidative stress.' },
        { glyph: '✦', name: 'Vitamin C', dose: '80 mg', sci: 'Water-phase antioxidant that also regenerates the reduced form of vitamin E.' },
        { glyph: '✧', name: 'Selenium', dose: '55 µg', sci: 'Core component of glutathione peroxidase, the body’s master antioxidant enzyme system.' },
        { glyph: '❂', name: 'Grape Seed', dose: '100 mg', sci: 'Concentrated oligomeric proanthocyanidins (OPCs) — among the most studied plant polyphenols.' }
      ]
    }
  };

  // Unselected pill dot colours.
  var PILL_COLORS = { glow: '#FFB700', defence: '#FF0038', clarity: '#A600FF', gutflora: '#5D9F16', cleanse: '#3D5AE8' };

  // Particle motifs per flavour.
  var GLYPHS = {
    glow: ['✦', '✧', '✦'],
    defence: ['✚', '❖', '◆'],
    clarity: ['◉', '✧', '☄'],
    gutflora: ['☘', '❀', '✿'],
    cleanse: ['☾', '✦', '☽']
  };

  /* ======================================================================
     Runtime
     ====================================================================== */

  var assets = {};
  var root, cfg;
  var active = 'glow';
  var cartCount = 0;
  var emptyPresses = 0;
  var adding = false;
  var particlesOn = true;
  var carIdx = 0;
  var carPages = 1;
  var carAnim = null;        // requestAnimationFrame id for the carousel tween
  var carTweening = false;   // true while the tween is driving scrollLeft
  var heroMinH = 0;          // tallest hero copy seen, to stop the phone jump
  var overWhite;
  var timers = {};
  var effectsReady = false; // heavy canvas effects mount only after first paint
  var rafAscii = null;
  var rafPrism = null;
  var prismGl = null;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function asset(key) { return assets[key] || ''; }

  /* Apply a mask image with a literal URL. Both the prefixed and unprefixed
     properties are set because Safari still needs -webkit-. See the note on
     .alc-pill-icon in alchemica.css for why this is not done with a var(). */
  function setMask(el, url) {
    if (!el || !url) return;
    var v = 'url("' + url + '")';
    el.style.webkitMaskImage = v;
    el.style.maskImage = v;
  }
  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function onShopify() { return typeof window !== 'undefined' && !!window.Shopify; }

  /* Replace every character with a random occult-looking glyph. Used to
     tease the four unreleased flavours without inventing fake facts. */
  /* Every glyph here is one that monospace faces actually contain, which is
     the whole reason the list looks like this.

     The original set used rarer sigils (⨊ ⍍ ⟁ ⏃ ⍾ and friends). No monospace
     font ships them, so each one fell back to a proportional symbol font: I
     measured widths from 7px to 16px across the set, against a fixed cell of
     8.8px. Every re-roll therefore produced a different line count, and the
     cards and table rows around the text resized twice a second.

     These are drawn from the maths-operator, Greek and geometric blocks, which
     Consolas, Menlo, SF Mono, DejaVu Sans Mono and Roboto Mono all cover. Same
     arcane look, one uniform advance width, so a re-roll cannot change where
     the lines break. If you add to this list, use something from those blocks —
     anything exotic enough to be missing from monospace fonts brings the
     shuddering straight back. */
  var SCRAMBLE_GLYPHS = '⌐¬∆∂∫∑∏√≡≠≈∞±÷×ΞΨΦΘΛΣΩΓ†‡§¶◊○●▪#%@*+=?';
  function scramble(str) {
    str = str == null ? '' : String(str);
    var out = '';
    for (var i = 0; i < str.length; i++) {
      out += str[i] === ' ' ? ' ' : SCRAMBLE_GLYPHS[(Math.random() * SCRAMBLE_GLYPHS.length) | 0];
    }
    return out;
  }

  /* ---- Theme ---------------------------------------------------------- */

  function applyTheme(id) {
    var v = PRODUCTS[id].vars;
    var s = root.style;
    s.setProperty('--alc-ac', v.ac);
    s.setProperty('--alc-ac-deep', v.acDeep);
    s.setProperty('--alc-ac-light', v.acLight);
    s.setProperty('--alc-halo', v.halo);
    s.setProperty('--alc-glow', v.glow);
    s.setProperty('--alc-ink', v.ink);
    s.setProperty('--alc-ink-soft', v.inkSoft);
    s.setProperty('--alc-glass', v.glass);
    s.setProperty('--alc-glass-brd', v.glassBrd);
    s.setProperty('--alc-card', v.card);
    s.setProperty('--alc-card-2', v.card2);
    s.setProperty('--alc-card-brd', v.cardBrd);
    s.setProperty('--alc-chip', v.chip);
    s.setProperty('--alc-chip-brd', v.chipBrd);
    s.setProperty('--alc-btn-fg', v.btnFg);
    s.setProperty('--alc-btn-bg', v.btnBg);
    s.setProperty('--alc-footer', v.footer);
    overWhite = undefined; // force updateNavInk to recompute
    updateNavInk();
  }

  /* The nav sits over both tinted and cream sections. Flip its ink and the
     logo variant whenever a cream band crosses the nav's vertical centre. */
  function updateNavInk() {
    var navMid = 50;
    var over = false;
    $$('.alc-band').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < navMid && r.bottom > navMid) over = true;
    });
    if (over === overWhite) return;
    overWhite = over;
    var v = PRODUCTS[active].vars;
    root.style.setProperty('--alc-nav-ink', over ? '#241505' : v.ink);
    root.style.setProperty('--alc-nav-glass', over ? 'rgba(255,255,255,.72)' : v.glass);
    var dark = over || !!v.darkInk;
    root.style.setProperty('--alc-logo-dark-op', dark ? '1' : '0');
    root.style.setProperty('--alc-logo-white-op', dark ? '0' : '1');
  }

  /* ---- Content rendering --------------------------------------------- */

  /* Scrambled text is tagged so the stylesheet can set it in a fixed-width
     face. The glyphs are re-rolled every 620ms; in a proportional font each
     roll is a different width, so the text re-wrapped, the line count changed
     and every box around it resized — a visible shudder. Because scramble()
     preserves the string length and the spaces exactly, a monospace face makes
     every roll wrap identically, so the characters change in place and nothing
     moves. */
  var CRYPT = ' alc-crypt';

  function nutritionHtml(p, locked) {
    var c = locked ? CRYPT : '';
    return p.nutrition.map(function (n) {
      var k = locked ? scramble(n.k) : n.k;
      var v = locked ? scramble(n.v) : n.v;
      var nrv = locked ? scramble(n.nrv) : n.nrv;
      return '<div class="alc-nutrition-row"><span class="' + c.slice(1) + '">' + esc(k) + '</span>' +
        '<span class="alc-nutrition-vals"><span class="' + c.slice(1) + '">' + esc(v) + '</span>' +
        '<span class="alc-nutrition-nrv' + c + '">' + esc(nrv) + '</span></span></div>';
    }).join('');
  }

  function ingredientsHtml(p, locked) {
    var c = locked ? CRYPT : '';
    return p.ingredients.map(function (ing) {
      var name = locked ? scramble(ing.name) : ing.name;
      var dose = locked ? scramble(ing.dose) : ing.dose;
      var sci = locked ? scramble(ing.sci) : ing.sci;
      var art = ing.art
        ? '<span class="alc-ing-art" aria-hidden="true" style="background-image:url(&quot;' + esc(asset(ing.art)) + '&quot;)"></span>'
        : '';
      return '<article class="alc-ing-card">' +
        '<div class="alc-ing-card-top">' +
          '<span class="alc-ing-glyph" aria-hidden="true">' + esc(ing.glyph) + '</span>' +
          '<span class="alc-ing-dose' + c + '">' + esc(dose) + '</span>' +
        '</div>' +
        '<h3 class="alc-ing-name' + c + '">' + esc(name) + '</h3>' +
        '<p class="alc-ing-sci' + c + '">' + esc(sci) + '</p>' +
        art +
      '</article>';
    }).join('');
  }

  function fullIngredientsHtml(p) {
    return (p.fullIngredients || []).map(function (fi) {
      return '<div class="alc-full-ing-row"><span>' + esc(fi.name) + '</span><span>' + esc(fi.dose) + '</span></div>';
    }).join('');
  }

  /* Crossfade to a flavour's background.

     The image is fetched BEFORE the opacity transition starts. Getting this
     wrong is very visible: if you fade the layer in first, the visitor sees the
     flat brand colour crossfade smoothly and then the texture pop in abruptly
     when it finishes downloading — which reads as the background snapping
     rather than blending.

     Backgrounds are several megabytes each, so they are still only fetched as
     needed; prefetchOtherBackgrounds() warms them during idle time so this is
     normally instant. */
  var bgToken = 0;

  function crossfadeBg(id) {
    var el = $('.alc-bg[data-bg="' + id + '"]');
    if (!el) return;
    var token = ++bgToken;

    function activate() {
      if (token !== bgToken) return; // a later switch already won
      ORDER.forEach(function (other) {
        var o = $('.alc-bg[data-bg="' + other + '"]');
        if (o) o.classList.toggle('is-active', other === id);
      });
    }

    if (el.dataset.loaded) { activate(); return; }

    var src = asset('bg-' + id);
    if (!src) { activate(); return; }

    var im = new Image();
    var fired = false;

    /* usePhoto=false means the file never arrived. In that case leave the
       element's background-image alone: the stylesheet has already put this
       flavour's gradient there, and overwriting it with a URL that does not
       resolve would paint nothing and expose the flat colour underneath. */
    function ready(usePhoto) {
      if (fired) return;
      fired = true;
      if (usePhoto) {
        // Photo on top, gradient still beneath it as the safety net.
        el.style.backgroundImage = 'url("' + src + '"), var(--alc-bg-fallback)';
      }
      el.dataset.loaded = '1';
      // One frame so the browser paints the background before the fade begins.
      requestAnimationFrame(activate);
    }

    // Wrapped rather than passed directly: onload/onerror hand over an Event and
    // setTimeout hands over a timer id, any of which would read as truthy.
    im.onload = function () { ready(true); };
    im.onerror = function () { ready(false); };
    im.src = src;
    if (im.complete) ready(true);              // already cached
    // Never strand the visitor on the old background. Still shows the photo —
    // it is merely slow, and by the time the fade ends it has usually landed.
    setTimeout(function () { ready(true); }, 2500);
  }

  /* One editable string. `fallback` is the wording shipped with the theme and is
     used whenever the setting is missing or has been cleared, so emptying a
     field in the theme editor restores the default rather than blanking the
     page. {name} expands to the current flavour's full product name. */
  function txt(key, fallback, name) {
    var v = (cfg.copy && cfg.copy[key]) || fallback;
    // split/join rather than replace(): a bare string argument to replace()
    // swaps only the FIRST match, while Liquid's `replace` filter — which
    // renders the very same settings for the first paint — swaps all of them.
    // Someone who used {name} twice would see the two disagree.
    return name ? v.split('{name}').join(name) : v;
  }

  function render() {
    var p = PRODUCTS[active];
    var isGlow = active === 'glow';

    /* Two independent states, both switchable from the theme editor while Glow
       is still in R&D:

       locked — the flavour is not for sale. Big name in the hero, silhouette
                jar, "coming soon" stamps, no way to buy. Always true for the
                four unreleased flavours; true for Glow only if it has been
                pulled back to that state deliberately.

       crypt  — the formula on the page is scrambled. Implied by locked, but
                also available on its own: that is the case where Glow is
                genuinely on sale and only the numbers are still moving, so the
                page keeps its buy button and hides the doses. */
    var locked = !isGlow || cfg.glowFullLock;
    var crypt = locked || cfg.glowCrypt;

    crossfadeBg(active);

    // Hero.
    var wordmark = $('.alc-wordmark');
    if (wordmark) wordmark.classList.toggle('alc-hidden', !isGlow);
    /* Locked flavours put their name in the h1 and then say nothing else. The
       description line used to repeat "Still in the lab, join the mailing
       list" — which the button directly underneath already says — so it was
       spending the best space on the page restating the CTA. Removing it lets
       the name grow into a real title; see [data-locked] in the CSS. */
    root.setAttribute('data-locked', locked ? '1' : '0');

    /* Keyed on `locked`, not on `isGlow`: a locked flavour shows its NAME as the
       big title. Glow pulled back into development is locked too, and its
       headline is a whole sentence — "Eat Your Skincare!" set at the 104px
       locked title size runs off the side of a phone. */
    $('[data-alc="hero-title"]').textContent = locked ? p.name : p.headline;
    var desc = $('[data-alc="hero-desc"]');
    desc.classList.toggle('alc-hidden', locked);
    if (isGlow) desc.textContent = txt('heroDesc', p.desc);

    var meta = $('[data-alc="hero-meta"]');
    meta.classList.toggle('alc-hidden', locked);
    if (!locked) {
      meta.textContent = cfg.preordersOpen
        ? txt('heroMetaPreorder', '✦ 60 gummies · ' + p.flavour + ' flavour · Pre-order now, ships at launch')
        : txt('heroMetaSoon', '✦ 60 gummies · ' + p.flavour + ' flavour · Pre-orders opening soon');
    }

    // Bottle.
    var img = $('[data-alc="bottle"]');
    img.src = asset(p.img);
    img.alt = locked ? p.name + ' — coming soon' : p.alt;
    img.classList.toggle('is-silhouette', locked);
    $('[data-alc="bottle-stamp"]').classList.toggle('alc-hidden', !locked);

    // Switcher pills.
    $$('.alc-pill').forEach(function (btn) {
      var id = btn.getAttribute('data-product');
      var on = id === active;
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
      var d = PRODUCTS[id];
      var color = on ? (d.vars.darkInk ? d.vars.ac : d.vars.acLight) : PILL_COLORS[id];
      var icon = btn.querySelector('.alc-pill-icon');
      if (icon) {
        icon.style.backgroundColor = color;
        icon.style.filter = 'drop-shadow(0 0 5px ' + color + ')';
      }
    });
    measureIndicator();

    // Shop card.
    $('[data-alc="full-name"]').textContent = p.fullName;
    $('[data-alc="nutrition"]').innerHTML = nutritionHtml(p, crypt);
    $('[data-alc="status"]').textContent = locked
      ? txt('statusLocked', 'Coming soon')
      : (cfg.preordersOpen ? txt('statusPreorder', 'Pre-order') : txt('statusSoon', 'Opening soon'));
    $('[data-alc="flavour"]').textContent = p.flavour;
    $('[data-alc="shop-copy"]').textContent = locked
      ? txt('shopCopyLocked', '{name} is still in the lab. Join the mailing list and you’ll hear the day it lands.', p.fullName)
      : (cfg.preordersOpen
          ? txt('shopCopyPreorder', '{name} is ready for pre-order. Reserve a jar from the first batch and join the list for shipping news.', p.fullName)
          : txt('shopCopySoon', '{name} is almost here. Pre-orders are not open quite yet — join the list and you’ll be the first to know when they are.', p.fullName));
    $('[data-alc="ing-link"]').classList.toggle('alc-hidden', locked);
    $$('[data-alc="lockable"]').forEach(function (el) { el.classList.toggle('alc-locked', crypt); });
    $$('[data-alc="stamp"]').forEach(function (el) { el.classList.toggle('alc-hidden', !locked); });

    // CTA buttons.
    var ctaLabel = adding ? txt('ctaLabelAdding', 'Adding…')
      : locked ? txt('ctaLabelLocked', 'Coming soon — keep up to date')
      : (cfg.preordersOpen ? txt('ctaLabelPreorder', 'Pre-order Glow') : cfg.ctaLabelClosed);
    $$('[data-alc="cta"]').forEach(function (b) {
      b.textContent = ctaLabel;
      b.disabled = adding;
    });

    // Ingredients section.
    var longDesc = $('[data-alc="long-desc"]');
    longDesc.textContent = crypt ? scramble(p.longDesc) : p.longDesc;
    longDesc.classList.toggle('alc-crypt', crypt);
    $('[data-alc="carousel"]').innerHTML = ingredientsHtml(p, crypt);
    carIdx = 0;
    var car = $('[data-alc="carousel"]');
    if (carAnim) { cancelAnimationFrame(carAnim); carAnim = null; carTweening = false; }
    if (car) {
      // The cards were just replaced, so this is a reset rather than a move —
      // it should be instant, not a visible slide back to the start.
      var prevBehavior = car.style.scrollBehavior;
      car.style.scrollBehavior = 'auto';
      car.style.scrollSnapType = '';
      car.scrollLeft = 0;
      car.style.scrollBehavior = prevBehavior;
    }
    carMeasure();
    markCurrentCard();

    // Campaign band is Glow-only, and only while Glow is actually launching —
    // a shop-the-campaign photo under a "coming soon" jar reads as a mistake.
    $('[data-alc="campaign"]').classList.toggle('alc-hidden', locked);
    var camp = $('[data-alc="campaign-img"]');
    if (camp) { camp.src = asset(p.campaign); camp.alt = p.campaignAlt; }

    // Full ingredient modal contents.
    var fi = $('[data-alc="full-ing"]');
    if (fi) fi.innerHTML = fullIngredientsHtml(p);

    buildParticles();
    stabiliseHero();
  }

  function isPhone() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 640px)').matches);
  }

  /* Phones only: hold the hero at the tallest height any flavour needs.

     Switching flavour changes what the hero contains — the Glow wordmark, the
     "60 gummies…" line and the description all disappear on a locked flavour,
     and the locked layout stacks into one column instead of two. Without a
     floor, everything underneath (including the picker the finger is still
     resting on) jumps up, then back down on the next tap.

     The floor goes on the GRID rather than on the copy column. Flooring the
     copy column was enough while every flavour shared one two-column layout,
     but a locked flavour now rearranges the grid itself, so the column's height
     no longer decides the hero's. Measuring the grid catches both.

     Measured rather than hard-coded, because the number depends on the screen
     width and on the visitor's own font-size setting. The floor is cleared
     before measuring so the natural height is what gets read, and it only ever
     grows — so once the tallest flavour has been rendered nothing moves again. */
  function stabiliseHero() {
    var grid = $('.alc-hero-grid');
    var copy = $('.alc-hero-copy');
    if (!grid) return;

    // Clear the older per-column floor: a visitor arriving with a cached page
    // could otherwise keep an inline min-height this code no longer sets.
    if (copy) copy.style.minHeight = '';

    if (!isPhone()) {
      grid.style.minHeight = '';
      heroMinH = 0;
      return;
    }

    grid.style.minHeight = '';
    // getBoundingClientRect rather than offsetHeight, and rounded up:
    // offsetHeight is a whole number, so a hero that is really 353.1px tall
    // would get a 353px floor and still shift by a fraction of a pixel.
    var natural = Math.ceil(grid.getBoundingClientRect().height);
    if (natural > heroMinH) heroMinH = natural;
    if (heroMinH) grid.style.minHeight = heroMinH + 'px';
  }

  /* Crossfade the bottle, then swap everything. */
  function setProduct(id) {
    if (id === active || !PRODUCTS[id]) return;
    var fade = $('.alc-bottle-fade');
    if (fade) fade.classList.add('is-swapping');
    clearTimeout(timers.hero);
    timers.hero = setTimeout(function () {
      active = id;
      render();
      applyTheme(id);
      if (fade) fade.classList.remove('is-swapping');
    }, 170);
  }

  /* ---- Switcher indicator -------------------------------------------- */

  function measureIndicator() {
    var pill = $('.alc-pill[data-product="' + active + '"]');
    var ind = $('.alc-switcher-ind');
    if (!pill || !ind) return;
    ind.style.left = pill.offsetLeft + 'px';
    ind.style.top = pill.offsetTop + 'px';
    ind.style.width = pill.offsetWidth + 'px';
    ind.style.height = pill.offsetHeight + 'px';
    ind.style.opacity = '1';
  }

  /* ---- Cart ---------------------------------------------------------- */

  function syncCart() {
    if (!onShopify()) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count || 0); })
      .catch(function () { /* leave the count at 0 */ });
  }

  /* Only the number is rewritten. Replacing the button's whole textContent
     would delete the bag glyph that phones show instead of the word "Cart". */
  function setCartCount(n) {
    cartCount = n;
    var el = $('[data-alc="cart-count"]');
    if (el) el.textContent = n;
    var btn = $('[data-alc="cart"]');
    // The word "Cart" is hidden on phones, so the label carries the meaning.
    if (btn) btn.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
  }

  function showBubble(msg, ms) {
    var wrap = $('.alc-cart-wrap');
    if (!wrap) return;
    var old = wrap.querySelector('.alc-bubble');
    if (old) old.remove();
    var b = document.createElement('div');
    b.className = 'alc-bubble';
    b.setAttribute('role', 'status');
    b.textContent = msg;
    wrap.appendChild(b);
    clearTimeout(timers.bubble);
    timers.bubble = setTimeout(function () { b.remove(); }, ms || 700);
  }

  /* Add Glow to the cart, then invite the shopper onto the mailing list.

     The pop-up replaces the old redirect-to-cart rather than joining it: a
     redirect unloads the page, so the two genuinely cannot both happen. The
     pop-up carries a "View cart & check out" button, so the route to checkout
     is one click rather than automatic. Shops that would rather send people
     straight to the cart can switch this in the theme editor. */
  function preorder() {
    if (!onShopify()) {
      // Local preview: no real cart, so just demonstrate the flow.
      setCartCount(cartCount + 1);
      openModal('signup', 'added');
      return;
    }
    if (!cfg.variantId) {
      showBubble('Pick the Glow product in the theme editor first');
      return;
    }
    adding = true;
    render();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: cfg.variantId, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        adding = false;
        render();
        syncCart();                    // pill shows the real server-side count
        if (cfg.postAdd === 'cart') {
          window.location.href = '/cart';
          return;
        }
        openModal('signup', 'added');
      })
      .catch(function () {
        adding = false;
        render();
        showBubble('Couldn’t add that — try again');
      });
  }

  function onCartClick() {
    if (cartCount > 0) {
      showBubble('✦ ' + cartCount + (cartCount === 1 ? ' item' : ' items') + ' — good taste');
      if (onShopify()) window.location.href = '/cart';
      return;
    }
    // Empty-cart easter egg.
    emptyPresses++;
    var msgs = ['nothing here :(', 'cart empty :0', '0 items :,(', '🛒'];
    var msg = emptyPresses >= 6 ? 'its still empty...' : msgs[Math.floor(Math.random() * msgs.length)];
    var btn = $('[data-alc="cart"]');
    if (btn) {
      btn.classList.add('is-shaking');
      clearTimeout(timers.shake);
      timers.shake = setTimeout(function () { btn.classList.remove('is-shaking'); }, 550);
    }
    showBubble(msg);
  }

  /* ---- Particles ----------------------------------------------------- */

  // Fixed pseudo-random positions so the field looks scattered but never
  // reshuffles between renders.
  var PTS = [];
  for (var i = 0; i < 14; i++) {
    PTS.push({
      left: (i * 7.3 + 3) % 100,
      size: 5 + ((i * 37) % 9),
      dur: 14 + ((i * 53) % 12),
      delay: -((i * 29) % 16)
    });
  }
  var BIGS = [['4%', '10%', 170, 11], ['76%', '4%', 120, 14], ['86%', '56%', 200, 12], ['8%', '64%', 95, 9], ['46%', '82%', 140, 16]];

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Tear down whatever effect is running. Essential when switching flavour:
     without this every switch would leak an animation loop and a WebGL
     context, and the page would grind to a halt after a few clicks. */
  function stopEffects() {
    if (rafAscii) { cancelAnimationFrame(rafAscii); rafAscii = null; }
    if (rafPrism) { cancelAnimationFrame(rafPrism); rafPrism = null; }
    if (prismGl) {
      var lose = prismGl.getExtension('WEBGL_lose_context');
      if (lose) lose.loseContext();
      prismGl = null;
    }
    // The canvases live on the root, so clear them explicitly.
    $$('.alc-fx-canvas').forEach(function (c) { c.remove(); });
  }

  /* Canvas effects mount on the root, not in .alc-particles — see the comment
     on .alc-fx-canvas in alchemica.css for why blending requires this. */
  function addFxCanvas(kind) {
    var el = document.createElement('canvas');
    el.className = 'alc-fx-canvas is-' + kind;
    el.setAttribute('aria-hidden', 'true');
    root.appendChild(el);
    return el;
  }

  /* Floating glyph field — Glow, Gut Flora and Cleanse. */
  function buildGlyphs(host) {
    var g = GLYPHS[active];
    host.innerHTML = BIGS.map(function (b) {
      return '<span class="alc-particle-big" style="left:' + b[0] + ';top:' + b[1] +
        ';font-size:' + b[2] + 'px;animation:alc-floatY ' + b[3] + 's ease-in-out infinite">' + esc(g[0]) + '</span>';
    }).join('') + PTS.map(function (pt, n) {
      return '<span class="alc-particle" style="left:' + pt.left + '%;font-size:' + Math.min(pt.size + 6, 17) +
        'px;animation:alc-drift ' + pt.dur + 's linear ' + pt.delay + 's infinite">' + esc(g[n % g.length]) + '</span>';
    }).join('');
  }

  /* ---- Defence: ASCII rain ------------------------------------------- */
  /* Overlapping sine fields drive a character-density ramp, with a diagonal
     "beam" brightening one sweep across the screen. Redraws at ~11fps by
     design — the steppy cadence is the look. */
  function startAscii(host) {
    var el = addFxCanvas('ascii');
    var ctx = el.getContext('2d');
    if (!ctx) { el.remove(); buildGlyphs(host); return; }

    var CH = ' ..::--==++xxXX8S80#@@';
    function hash(x, y, s) {
      var n = Math.sin(x * 127.1 + y * 311.7 + s * 74.7) * 43758.5453;
      return n - Math.floor(n);
    }
    var last = 0;

    function draw(t) {
      rafAscii = requestAnimationFrame(draw);
      if (t - last < 90) return;
      last = t;
      var W = el.clientWidth, H = el.clientHeight;
      if (!W || !H) return;
      if (el.width !== W || el.height !== H) { el.width = W; el.height = H; }
      ctx.clearRect(0, 0, W, H);
      ctx.font = '12px Consolas, "SF Mono", monospace';
      ctx.textBaseline = 'top';
      var cw = 13, chh = 17;
      var step = Math.floor(t / 260);
      for (var gy = 0; gy * chh < H; gy++) {
        for (var gx = 0; gx * cw < W; gx++) {
          var px = gx * cw, py = gy * chh;
          var v = Math.sin(gx * 0.32 + t * 0.00055 + Math.sin(gy * 0.21 - t * 0.00042) * 2.2)
                + Math.sin(gx * 0.11 - gy * 0.29 - t * 0.0009)
                + Math.sin((gx + gy) * 0.16 + t * 0.0005);
          v = (v + 3) / 6;
          var beam = Math.max(0, 1 - Math.abs(py - (H * 0.72 - px * 0.32)) / 150);
          v = Math.min(1, v * 0.72 + beam * 0.5 * v + beam * 0.12);
          var r = hash(gx, gy, step);
          if (v < 0.24 || r > v + 0.3) continue;
          var idx = Math.min(CH.length - 1, Math.floor(v * v * (CH.length - 1) + r * 3));
          var ch = CH[idx];
          if (ch === ' ') continue;
          var a = Math.min(0.85, v * v * 0.95 + 0.04);
          ctx.fillStyle = v > 0.78 ? 'rgba(255,242,238,' + a + ')'
            : v > 0.5 ? 'rgba(255,196,186,' + a + ')'
            : 'rgba(255,152,140,' + (a * 0.75).toFixed(3) + ')';
          ctx.fillText(ch, px, py);
        }
      }
    }
    rafAscii = requestAnimationFrame(draw);
  }

  /* ---- Clarity: volumetric prism (WebGL2) ---------------------------- */
  /* A raymarched light-ray volume tinted through the Clarity violet palette.
     Needs WebGL2; falls back to the glyph field on older devices. */
  function startPrism(host) {
    var el = addFxCanvas('prism');

    var gl = el.getContext('webgl2', { alpha: false, antialias: false });
    if (!gl) { el.remove(); buildGlyphs(host); return; }
    prismGl = gl;

    var vsSrc = '#version 300 es\nin vec2 position;\nvoid main(){ gl_Position = vec4(position, 0.0, 1.0); }';
    var fsSrc = `#version 300 es
precision highp float;
precision highp int;
out vec4 fragColor;
uniform vec2 uResolution;
uniform float uTime;
uniform float uIntensity;
uniform float uSpeed;
uniform int uAnimType;
uniform vec2 uMouse;
uniform int uColorCount;
uniform float uDistort;
uniform vec2 uOffset;
uniform sampler2D uGradient;
uniform float uNoiseAmount;
uniform int uRayCount;
float hash21(vec2 p){ p = floor(p); float f = 52.9829189 * fract(dot(p, vec2(0.065, 0.005))); return fract(f); }
mat2 rot30(){ return mat2(0.8, -0.5, 0.5, 0.8); }
float layeredNoise(vec2 fragPx){
  vec2 p = mod(fragPx + vec2(uTime * 30.0, -uTime * 21.0), 1024.0);
  vec2 q = rot30() * p;
  float n = 0.0;
  n += 0.40 * hash21(q);
  n += 0.25 * hash21(q * 2.0 + 17.0);
  n += 0.20 * hash21(q * 4.0 + 47.0);
  n += 0.10 * hash21(q * 8.0 + 113.0);
  n += 0.05 * hash21(q * 16.0 + 191.0);
  return n;
}
vec3 rayDir(vec2 frag, vec2 res, vec2 offset, float dist){
  float focal = res.y * max(dist, 1e-3);
  return normalize(vec3(2.0 * (frag - offset) - res, focal));
}
float edgeFade(vec2 frag, vec2 res, vec2 offset){
  vec2 toC = frag - 0.5 * res - offset;
  float r = length(toC) / (0.5 * min(res.x, res.y));
  float x = clamp(r, 0.0, 1.0);
  float q = x * x * x * (x * (x * 6.0 - 15.0) + 10.0);
  float s = q * 0.5;
  s = pow(s, 1.5);
  float tail = 1.0 - pow(1.0 - s, 2.0);
  s = mix(s, tail, 0.2);
  float dn = (layeredNoise(frag * 0.15) - 0.5) * 0.0015 * s;
  return clamp(s + dn, 0.0, 1.0);
}
mat3 rotX(float a){ float c = cos(a), s = sin(a); return mat3(1.0,0.0,0.0, 0.0,c,-s, 0.0,s,c); }
mat3 rotY(float a){ float c = cos(a), s = sin(a); return mat3(c,0.0,s, 0.0,1.0,0.0, -s,0.0,c); }
mat3 rotZ(float a){ float c = cos(a), s = sin(a); return mat3(c,-s,0.0, s,c,0.0, 0.0,0.0,1.0); }
vec3 sampleGradient(float t){ t = clamp(t, 0.0, 1.0); return texture(uGradient, vec2(t, 0.5)).rgb; }
vec2 rot2(vec2 v, float a){ float s = sin(a), c = cos(a); return mat2(c, -s, s, c) * v; }
float bendAngle(vec3 q, float t){
  float a = 0.8 * sin(q.x * 0.55 + t * 0.6)
          + 0.7 * sin(q.y * 0.50 - t * 0.5)
          + 0.6 * sin(q.z * 0.60 + t * 0.7);
  return a;
}
void main(){
  vec2 frag = gl_FragCoord.xy;
  float t = uTime * uSpeed;
  float jitterAmp = 0.1 * clamp(uNoiseAmount, 0.0, 1.0);
  vec3 dir = rayDir(frag, uResolution, uOffset, 1.0);
  float marchT = 0.0;
  vec3 col = vec3(0.0);
  float n = layeredNoise(frag);
  vec4 c = cos(t * 0.2 + vec4(0.0, 33.0, 11.0, 0.0));
  mat2 M2 = mat2(c.x, c.y, c.z, c.w);
  float amp = clamp(uDistort, 0.0, 50.0) * 0.15;
  mat3 rot3dMat = mat3(1.0);
  if(uAnimType == 1){
    vec3 ang = vec3(t * 0.31, t * 0.21, t * 0.17);
    rot3dMat = rotZ(ang.z) * rotY(ang.y) * rotX(ang.x);
  }
  mat3 hoverMat = mat3(1.0);
  if(uAnimType == 2){
    vec2 m = uMouse * 2.0 - 1.0;
    vec3 ang = vec3(m.y * 0.6, m.x * 0.6, 0.0);
    hoverMat = rotY(ang.y) * rotX(ang.x);
  }
  for (int i = 0; i < 44; ++i) {
    vec3 P = marchT * dir;
    P.z -= 2.0;
    float rad = length(P);
    vec3 Pl = P * (10.0 / max(rad, 1e-6));
    if(uAnimType == 0){ Pl.xz *= M2; }
    else if(uAnimType == 1){ Pl = rot3dMat * Pl; }
    else { Pl = hoverMat * Pl; }
    float stepLen = min(rad - 0.3, n * jitterAmp) + 0.1;
    float grow = smoothstep(0.35, 3.0, marchT);
    float a1 = amp * grow * bendAngle(Pl * 0.6, t);
    float a2 = 0.5 * amp * grow * bendAngle(Pl.zyx * 0.5 + 3.1, t * 0.9);
    vec3 Pb = Pl;
    Pb.xz = rot2(Pb.xz, a1);
    Pb.xy = rot2(Pb.xy, a2);
    float rayPattern = smoothstep(
      0.5, 0.7,
      sin(Pb.x + cos(Pb.y) * cos(Pb.z)) *
      sin(Pb.z + sin(Pb.y) * cos(Pb.x + t))
    );
    if (uRayCount > 0) {
      float ang = atan(Pb.y, Pb.x);
      float comb = 0.5 + 0.5 * cos(float(uRayCount) * ang);
      comb = pow(comb, 3.0);
      rayPattern *= smoothstep(0.15, 0.95, comb);
    }
    vec3 spectralDefault = 1.0 + vec3(
      cos(marchT * 3.0 + 0.0),
      cos(marchT * 3.0 + 1.0),
      cos(marchT * 3.0 + 2.0)
    );
    float saw = fract(marchT * 0.25);
    float tRay = saw * saw * (3.0 - 2.0 * saw);
    vec3 userGradient = 2.0 * sampleGradient(tRay);
    vec3 spectral = (uColorCount > 0) ? userGradient : spectralDefault;
    vec3 base = (0.05 / (0.4 + stepLen))
              * smoothstep(5.0, 0.0, rad)
              * spectral;
    col += base * rayPattern;
    marchT += stepLen;
  }
  col *= edgeFade(frag, uResolution, uOffset);
  col *= uIntensity;
  fragColor = vec4(clamp(col, 0.0, 1.0), 1.0);
}`;

    function compile(type, src) {
      var sh = gl.createShader(type);
      gl.shaderSource(sh, src);
      gl.compileShader(sh);
      if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) {
        console.warn('Alchemica prism shader:', gl.getShaderInfoLog(sh));
        return null;
      }
      return sh;
    }
    var vs = compile(gl.VERTEX_SHADER, vsSrc);
    var fs = compile(gl.FRAGMENT_SHADER, fsSrc);
    if (!vs || !fs) { prismGl = null; el.remove(); buildGlyphs(host); return; }

    var prog = gl.createProgram();
    gl.attachShader(prog, vs);
    gl.attachShader(prog, fs);
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) {
      console.warn('Alchemica prism link:', gl.getProgramInfoLog(prog));
      prismGl = null; el.remove(); buildGlyphs(host); return;
    }
    gl.useProgram(prog);

    // One oversized triangle covers the viewport — cheaper than two.
    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var posLoc = gl.getAttribLocation(prog, 'position');
    gl.enableVertexAttribArray(posLoc);
    gl.vertexAttribPointer(posLoc, 2, gl.FLOAT, false, 0, 0);

    function U(n) { return gl.getUniformLocation(prog, n); }

    // Clarity palette, as a 3-pixel gradient texture the shader samples.
    var colors = [[213, 182, 255], [138, 92, 240], [255, 255, 255]];
    var tex = gl.createTexture();
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, tex);
    var data = new Uint8Array(colors.length * 4);
    colors.forEach(function (c, i) {
      data[i * 4] = c[0]; data[i * 4 + 1] = c[1]; data[i * 4 + 2] = c[2]; data[i * 4 + 3] = 255;
    });
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, colors.length, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

    gl.uniform1i(U('uGradient'), 0);
    gl.uniform1f(U('uIntensity'), 1.7);
    gl.uniform1f(U('uSpeed'), 0.35);
    gl.uniform1i(U('uAnimType'), 1);
    gl.uniform2f(U('uMouse'), 0.5, 0.5);
    gl.uniform1i(U('uColorCount'), colors.length);
    gl.uniform1f(U('uDistort'), 6.0);
    gl.uniform2f(U('uOffset'), 0, 0);
    gl.uniform1f(U('uNoiseAmount'), 0.8);
    gl.uniform1i(U('uRayCount'), 0);

    var uRes = U('uResolution'), uTime = U('uTime');

    function draw(t) {
      rafPrism = requestAnimationFrame(draw);
      var w = el.clientWidth, h = el.clientHeight;
      if (!w || !h) return;
      if (el.width !== w || el.height !== h) { el.width = w; el.height = h; gl.viewport(0, 0, w, h); }
      gl.uniform2f(uRes, w, h);
      gl.uniform1f(uTime, t * 0.001);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    }
    rafPrism = requestAnimationFrame(draw);
  }

  /* Pick the right effect for the active flavour. */
  function buildParticles() {
    var host = $('[data-alc="particles"]');
    if (!host) return;
    stopEffects();
    host.innerHTML = '';
    // effectsReady defers all of this until after first paint, so the heavy
    // canvases never compete with the hero for loading time.
    if (!particlesOn || !effectsReady) return;
    if (active === 'defence') startAscii(host);
    else if (active === 'clarity') startPrism(host);
    else buildGlyphs(host);
  }

  function toggleParticles() {
    particlesOn = !particlesOn;
    try { localStorage.setItem('alchemica-particles', particlesOn ? '1' : '0'); } catch (e) { /* private mode */ }
    var btn = $('[data-alc="particles-toggle"]');
    if (btn) btn.textContent = '✦ particles ' + (particlesOn ? 'on' : 'off');
    buildParticles();
  }

  /* Once the page is loaded, settled and idle, quietly warm the four
     backgrounds the visitor hasn't seen yet, so switching flavour is instant
     instead of pausing on a multi-megabyte download.

     This is deliberately polite: it runs at low priority after everything else,
     and bails out entirely on metered or slow connections — pushing ~17 MB of
     backgrounds at someone on 2G or with Data Saver on would be rude. Those
     visitors still get each background on demand. */
  function prefetchOtherBackgrounds() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (c) {
      if (c.saveData) return;
      if (/2g/.test(c.effectiveType || '')) return;
    }
    ORDER.forEach(function (id) {
      if (id === active) return;
      var im = new Image();
      im.fetchPriority = 'low';
      im.decoding = 'async';
      im.src = asset('bg-' + id);
    });
  }

  /* Wait for full load, then an idle slot, before starting any effect. */
  function enableEffects() {
    function go() {
      effectsReady = true;
      buildParticles();
      // Backgrounds come last: never ahead of the visible effect.
      if ('requestIdleCallback' in window) requestIdleCallback(prefetchOtherBackgrounds, { timeout: 8000 });
      else setTimeout(prefetchOtherBackgrounds, 2500);
    }
    function schedule() {
      if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2000 });
      else setTimeout(go, 600);
    }
    if (document.readyState === 'complete') schedule();
    else {
      window.addEventListener('load', schedule, { once: true });
      timers.fx = setTimeout(schedule, 4000); // safety net if load never fires
    }
  }

  /* ---- Magic sparkles ------------------------------------------------ */

  function scheduleStar() {
    timers.star = setTimeout(function () {
      spawnStar();
      scheduleStar();
    }, 1800 + Math.random() * 3400);
  }

  function spawnStar() {
    var host = $('[data-alc="magic"]');
    if (!host) return;
    var colors = ['rgb(123,31,162)', 'rgb(103,58,183)', 'rgb(244,143,177)'];
    var s = document.createElement('span');
    s.className = 'alc-magic-star';
    s.setAttribute('aria-hidden', 'true');
    s.style.left = (Math.random() * 116 - 8).toFixed(1) + '%';
    s.style.top = (Math.random() * 132 - 16).toFixed(1) + '%';
    var size = (11 + Math.random() * 17).toFixed(0) + 'px';
    s.style.width = size;
    s.style.height = size;
    var inner = document.createElement('span');
    inner.style.background = colors[(Math.random() * colors.length) | 0];
    setMask(inner, asset('star'));
    s.appendChild(inner);
    host.appendChild(s);
    setTimeout(function () { s.remove(); }, 780);
  }

  /* ---- Ingredient carousel ------------------------------------------ */

  function carStep() {
    var el = $('[data-alc="carousel"]');
    var card = el && el.firstElementChild;
    return card ? card.getBoundingClientRect().width + 16 : 0;
  }

  // One dot per reachable scroll position, not per card.
  function carMeasure() {
    var el = $('[data-alc="carousel"]');
    if (!el) return;
    var step = carStep();
    var pages = step ? Math.max(1, Math.round((el.scrollWidth - el.clientWidth) / step) + 1) : 1;
    var host = $('[data-alc="dots"]');
    // Also render when the host is still empty: on first measure `pages` can
    // already equal the starting value of carPages, which would skip the build.
    if (pages !== carPages || !host || !host.children.length) {
      carPages = pages;
      renderDots();
    } else {
      updateDots();
    }
  }

  function renderDots() {
    var host = $('[data-alc="dots"]');
    if (!host) return;
    var html = '';
    for (var n = 0; n < carPages; n++) {
      html += '<button class="alc-car-dot" data-car-dot="' + n + '" aria-label="Go to ingredient ' + (n + 1) + '"></button>';
    }
    host.innerHTML = html;
    updateDots();
  }

  function updateDots() {
    $$('[data-car-dot]').forEach(function (d) {
      d.classList.toggle('is-active', Number(d.getAttribute('data-car-dot')) === carIdx);
    });
  }

  function carGo(n) {
    var el = $('[data-alc="carousel"]');
    if (!el) return;
    carIdx = Math.max(0, Math.min(n, carPages - 1));
    updateDots();
    carTweenTo(el, carIdx * carStep());
  }

  /* Animate the carousel by hand instead of asking the browser for
     `behavior: 'smooth'`.

     Two reasons the built-in version was landing as a hard cut:

     1. `scroll-snap-type: x mandatory` fights a programmatic smooth scroll.
        The snap engine sees the scroll position leave a snap point and yanks
        it to the destination on the first frame, so the animation never runs.
        Suspending snapping for the duration of the tween is the fix — it goes
        back on at the end, so swiping still snaps normally.
     2. Support for smooth `scrollTo` on the scroller (rather than the window)
        is uneven on older mobile Safari, where it silently falls back to an
        instant jump.

     A reduced-motion preference still gets the instant jump, deliberately. */
  function carTweenTo(el, to) {
    if (carAnim) { cancelAnimationFrame(carAnim); carAnim = null; }

    var max = Math.max(0, el.scrollWidth - el.clientWidth);
    to = Math.max(0, Math.min(to, max));
    var from = el.scrollLeft;
    var dist = to - from;
    if (Math.abs(dist) < 1) { markCurrentCard(); return; }

    if (reducedMotion()) {
      el.scrollLeft = to;
      markCurrentCard();
      return;
    }

    var snap = el.style.scrollSnapType;
    el.style.scrollSnapType = 'none';
    carTweening = true;

    // Longer trips take a little longer, but never long enough to feel slow.
    var dur = Math.min(620, Math.max(300, Math.abs(dist) * 0.85));
    var t0 = 0;

    function frame(now) {
      if (!t0) t0 = now;
      var t = Math.min(1, (now - t0) / dur);
      var eased = 1 - Math.pow(1 - t, 3);   // ease-out cubic
      el.scrollLeft = from + dist * eased;
      markCurrentCard();
      if (t < 1) {
        carAnim = requestAnimationFrame(frame);
      } else {
        carAnim = null;
        carTweening = false;
        el.style.scrollSnapType = snap;
      }
    }
    carAnim = requestAnimationFrame(frame);
  }

  /* Flag whichever card is nearest the middle of the viewport so CSS can bring
     it up to full size and dim the rest. Rects rather than offsetLeft: the
     cards are position:relative, so their offsetParent is not the scroller and
     offsetLeft would not share an origin with scrollLeft. */
  function markCurrentCard() {
    var el = $('[data-alc="carousel"]');
    if (!el) return;
    var kids = el.children;
    if (!kids.length) return;
    var box = el.getBoundingClientRect();
    var mid = box.left + box.width / 2;
    var best = 0;
    var bestD = Infinity;
    for (var i = 0; i < kids.length; i++) {
      var r = kids[i].getBoundingClientRect();
      var d = Math.abs(r.left + r.width / 2 - mid);
      if (d < bestD) { bestD = d; best = i; }
    }
    for (var j = 0; j < kids.length; j++) {
      kids[j].classList.toggle('is-current', j === best);
    }
  }

  function onCarScroll() {
    var el = $('[data-alc="carousel"]');
    if (!el) return;
    markCurrentCard();
    // While the tween is driving scrollLeft, leave carIdx alone — otherwise the
    // intermediate positions would drag the active dot backwards and forwards.
    if (carTweening) return;
    carMeasure();
    var step = carStep();
    var n = Math.max(0, Math.min(step ? Math.round(el.scrollLeft / step) : 0, carPages - 1));
    if (n !== carIdx) { carIdx = n; updateDots(); }
  }

  /* ---- Modals ------------------------------------------------------- */

  /* `mode` applies only to the signup pop-up: 'soon' for a coming-soon flavour,
     'added' after a successful pre-order. It swaps the copy and reveals the
     cart actions. */
  function openModal(which, mode) {
    var m = $('[data-alc="modal-' + which + '"]');
    if (!m) return;

    if (which === 'signup') {
      mode = mode || 'soon';
      var shownTitle = null;
      m.querySelectorAll('[data-alc="signup-copy"]').forEach(function (block) {
        var on = block.getAttribute('data-mode') === mode;
        block.classList.toggle('alc-hidden', !on);
        var h = block.querySelector('h3');
        // Clear the id from every heading first — two elements sharing an id
        // is invalid, and aria-labelledby would resolve to the wrong one.
        if (h) { h.removeAttribute('id'); if (on) shownTitle = h; }
      });
      var actions = m.querySelector('[data-alc="cart-actions"]');
      if (actions) actions.classList.toggle('alc-hidden', mode !== 'added');
      // The two list-only modes are a single small ask, so they get the
      // compact panel. 'added' and 'soon' carry more to read and stay full.
      var panel = m.querySelector('.alc-modal');
      if (panel) panel.classList.toggle('is-micro', mode === 'closed' || mode === 'auto');
      // Keep the accessible name pointing at the heading actually on screen.
      if (shownTitle) {
        shownTitle.id = 'alc-signup-title';
        m.querySelector('.alc-modal').setAttribute('aria-labelledby', 'alc-signup-title');
      }
    }

    m.classList.remove('alc-hidden');
    var input = m.querySelector('input[type="email"]');
    if (input) setTimeout(function () { input.focus(); }, 50);
    document.addEventListener('keydown', onEsc);
  }

  function closeModal(which) {
    var m = $('[data-alc="modal-' + which + '"]');
    var wasOpen = !!m && !m.classList.contains('alc-hidden');
    if (m) m.classList.add('alc-hidden');
    document.removeEventListener('keydown', onEsc);
    /* Someone who has seen the sign-up form and closed it has answered the
       question, whichever mode put it in front of them. Don't ask again.

       Only when it was genuinely on screen, though: onEsc closes both modals
       blind, so without the check, shutting the ingredient list with Escape
       would count as declining a mailing-list pop-up they never saw. */
    if (which === 'signup' && wasOpen) settleList();
  }

  function onEsc(e) {
    if (e.key === 'Escape') { closeModal('signup'); closeModal('ingredients'); }
  }

  /* ---- Timed mailing-list pop-up ------------------------------------ */

  /* One interruption per visitor, and only if they have never joined the list
     or closed the sign-up before. That flag is the entire politeness
     mechanism — without it the pop-up returns on every page view, which is
     what makes these things hated.

     localStorage throws outright in some private-browsing modes, so every
     access is wrapped. A browser that refuses to remember simply shows the
     pop-up again on the next visit: annoying, not broken. */
  var LIST_KEY = 'alchemica-list';
  var autoTries = 0;

  function listSettled() {
    try { return localStorage.getItem(LIST_KEY) === '1'; } catch (e) { return false; }
  }

  function settleList() {
    clearTimeout(timers.autoPopup);
    try { localStorage.setItem(LIST_KEY, '1'); } catch (e) { /* private mode */ }
  }

  function anyModalOpen() {
    return $$('.alc-modal-overlay').some(function (m) {
      return !m.classList.contains('alc-hidden');
    });
  }

  /* Armed when the splash clears, not when the script runs. The splash covers
     the page for up to a few seconds; counting through it would mean the
     pop-up landing almost the instant the page became visible. */
  function armAutoPopup() {
    if (!cfg.autoPopup || listSettled()) return;
    timers.autoPopup = setTimeout(fireAutoPopup, cfg.autoPopupDelay);
  }

  function fireAutoPopup() {
    if (listSettled()) return;
    // Never talk over a pop-up they opened themselves, and don't burn the one
    // appearance on a background tab. Wait for a gap instead — but give up
    // rather than following them around the page indefinitely.
    if (anyModalOpen() || document.hidden) {
      if (++autoTries > 6) return;
      timers.autoPopup = setTimeout(fireAutoPopup, 5000);
      return;
    }
    openModal('signup', 'auto');
  }

  /* ---- Splash ------------------------------------------------------- */

  /* The splash is the cover for image loading, so it waits for the things that
     decide the first impression — the active background, the hero bottle, the
     logo and the webfonts — rather than a fixed timer. Three bounds keep it
     honest:
       MIN_MS  the brand moment always plays, even from a warm cache
       MAX_MS  nobody is ever trapped behind a slow or broken asset
       onerror a missing file counts as done instead of hanging forever
     Backgrounds are multi-megabyte lossless files, so without this the splash
     would clear before the page behind it was ready to be seen. */
  var SPLASH_MIN_MS = 2600;
  var SPLASH_MAX_MS = 12000;

  function startSplash() {
    var splash = $('.alc-splash');
    if (!splash) {
      root.style.setProperty('--alc-intro-play', 'running');
      armAutoPopup();                 // nothing to wait behind
      return;
    }

    var started = Date.now();
    var finished = false;

    function finish() {
      if (finished) return;
      finished = true;
      clearTimeout(timers.splashCap);
      var wait = Math.max(0, SPLASH_MIN_MS - (Date.now() - started));
      timers.splash = setTimeout(function () {
        splash.classList.add('is-hiding');
        // Entrance animations start as the splash fades.
        root.style.setProperty('--alc-intro-play', 'running');
        timers.splash2 = setTimeout(function () { splash.remove(); }, 750);
        // The page is now genuinely on screen, so the pop-up's clock can start.
        armAutoPopup();
      }, wait);
    }

    // Hard ceiling, set before anything can block.
    timers.splashCap = setTimeout(finish, SPLASH_MAX_MS);

    var waits = [asset('bg-' + active), asset('bottle-glow'), asset('logo-black')]
      .filter(function (s) { return !!s; });
    var remaining = waits.length + 1; // +1 for fonts

    function tick() { if (--remaining <= 0) finish(); }

    waits.forEach(function (src) {
      var im = new Image();
      var counted = false;
      function once() { if (counted) return; counted = true; tick(); }
      im.onload = once;
      im.onerror = once;
      im.src = src;
      if (im.complete) once(); // already cached
    });

    // Wait for the display faces too, so the headline doesn't swap fonts
    // immediately after the splash clears.
    if (document.fonts && document.fonts.ready) {
      var fontsCounted = false;
      var fontsDone = function () {
        if (fontsCounted) return;
        fontsCounted = true;
        // The reserved hero height was measured in the fallback font. Now that
        // the real faces are in, re-measure — otherwise the floor is a few
        // pixels short and the jump comes back on the first flavour switch.
        heroMinH = 0;
        stabiliseHero();
        tick();
      };
      document.fonts.ready.then(fontsDone).catch(fontsDone);
      setTimeout(fontsDone, 4000); // fonts must not be the thing that stalls us
    } else {
      tick();
    }
  }

  /* ---- Bottle scroll fade ------------------------------------------- */

  function watchBottle() {
    var el = $('.alc-bottle-fade');
    if (!el) return;
    if (!('IntersectionObserver' in window)) { el.classList.add('is-visible'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('is-visible', e.isIntersecting); });
    }, { threshold: 0.2 });
    io.observe(el);
  }

  /* ---- Boot --------------------------------------------------------- */

  function init() {
    root = document.getElementById('alc-root');
    if (!root) return;

    /* Never wire the same markup twice.

       Shopify's theme editor re-inserts a section — including its <script> tag
       — every time you change a setting, and a re-inserted script re-executes.
       Without this guard every control would collect a second click handler.
       Most would just fire twice harmlessly, but any handler that TOGGLES
       would undo itself: two handlers on the menu button open it and then
       immediately close it again, so the menu appears completely dead.

       Keying off the element means a genuinely new section (editor re-render)
       still gets wired, while the same one is never wired twice. */
    if (root.dataset.alcInit) return;
    root.dataset.alcInit = '1';

    // Fallback for browsers without :has() — see the hide rules in alchemica.css.
    document.documentElement.classList.add('alc-page');

    // Config and asset URLs come from Liquid.
    try {
      assets = JSON.parse(document.getElementById('alc-assets').textContent);
    } catch (e) { assets = {}; }
    cfg = {
      variantId: root.getAttribute('data-variant-id') || '',
      defaultProduct: root.getAttribute('data-default-product') || 'glow',
      postAdd: root.getAttribute('data-post-add') || 'popup',
      // Until this is switched on in the theme editor, Glow behaves like the
      // other four: the button collects an email instead of selling anything.
      preordersOpen: root.getAttribute('data-preorders-open') === '1',
      ctaLabelClosed: assets.ctaLabelClosed || 'Join Pre-Order Waitlist',
      // Timed mailing-list pop-up. Absent attribute means an older copy of the
      // section markup, so default it on rather than silently doing nothing.
      autoPopup: root.getAttribute('data-autopopup') !== '0',
      autoPopupDelay: Math.max(1, Number(root.getAttribute('data-autopopup-delay')) || 6) * 1000,
      /* R&D switches for Glow. Both default OFF when the attribute is missing,
         so an older copy of the section markup shows the finished product
         rather than accidentally hiding the formula of the one flavour that is
         actually for sale. */
      glowCrypt: root.getAttribute('data-glow-crypt') === '1',
      glowFullLock: root.getAttribute('data-glow-locked') === '1',
      /* Every string the script writes into the page, editable in the theme
         editor. Older section markup has no "copy" key at all, so each read
         goes through txt() and falls back to the wording built in here. */
      copy: assets.copy || {}
    };
    if (PRODUCTS[cfg.defaultProduct]) active = cfg.defaultProduct;

    // The splash mask is set inline by Liquid; fill it in only if missing.
    var splashMask = $('.alc-splash-mask');
    if (splashMask && !splashMask.style.maskImage && !splashMask.style.webkitMaskImage) {
      var v = 'url("' + asset('logo-black') + '"), linear-gradient(#fff, #fff)';
      splashMask.style.webkitMaskImage = v;
      splashMask.style.maskImage = v;
    }
    // Liquid sets each glyph's mask inline so they paint on the first frame.
    // This only fills in a gap if the markup was rendered without it.
    ORDER.forEach(function (id) {
      var icon = $('.alc-pill[data-product="' + id + '"] .alc-pill-icon');
      if (!icon) return;
      if (!icon.style.maskImage && !icon.style.webkitMaskImage) {
        setMask(icon, asset('icon-' + id));
      }
    });
    // The starting flavour's background is set inline by the Liquid template so
    // it paints without waiting for this script. crossfadeBg() handles the rest.

    // Full-screen animated fields are exactly what reduced-motion is for, so
    // they start off for those visitors. But an explicit click on the toggle
    // always wins and is remembered — nobody is locked out of the effects.
    particlesOn = !reducedMotion();
    try {
      var stored = localStorage.getItem('alchemica-particles');
      if (stored !== null) particlesOn = stored === '1';
    } catch (e) { /* private mode */ }
    var pt = $('[data-alc="particles-toggle"]');
    if (pt) pt.textContent = '✦ particles ' + (particlesOn ? 'on' : 'off');

    // Events.
    $$('.alc-pill').forEach(function (btn) {
      btn.addEventListener('click', function () { setProduct(btn.getAttribute('data-product')); });
    });
    $$('[data-alc-shop]').forEach(function (btn) {
      btn.addEventListener('click', function () { setProduct(btn.getAttribute('data-alc-shop')); });
    });
    $$('[data-alc="cta"]').forEach(function (b) {
      b.addEventListener('click', function () {
        // Glow pulled back to "coming soon" behaves like the other four, and
        // must not reach preorder() — the label says it cannot be bought.
        if (active === 'glow' && !cfg.glowFullLock) {
          // Pre-orders closed: collect the email rather than the sale.
          if (!cfg.preordersOpen) { openModal('signup', 'closed'); return; }
          preorder();
          return;
        }
        openModal('signup', 'soon');
      });
    });
    var cartBtn = $('[data-alc="cart"]');
    if (cartBtn) cartBtn.addEventListener('click', onCartClick);
    if (pt) pt.addEventListener('click', toggleParticles);

    var openIng = $('[data-alc="open-ingredients"]');
    if (openIng) openIng.addEventListener('click', function () { openModal('ingredients'); });

    ['signup', 'ingredients'].forEach(function (which) {
      var m = $('[data-alc="modal-' + which + '"]');
      if (!m) return;
      // Click the backdrop (but not the panel) to close.
      m.addEventListener('click', function (e) { if (e.target === m) closeModal(which); });
      m.querySelectorAll('[data-alc="modal-close"]').forEach(function (b) {
        b.addEventListener('click', function () { closeModal(which); });
      });
    });

    var car = $('[data-alc="carousel"]');
    if (car) car.addEventListener('scroll', onCarScroll, { passive: true });
    var prev = $('[data-alc="car-prev"]');
    var next = $('[data-alc="car-next"]');
    if (prev) prev.addEventListener('click', function () { carGo(carIdx - 1); });
    if (next) next.addEventListener('click', function () { carGo(carIdx + 1); });
    var dotHost = $('[data-alc="dots"]');
    if (dotHost) dotHost.addEventListener('click', function (e) {
      var d = e.target.closest('[data-car-dot]');
      if (d) carGo(Number(d.getAttribute('data-car-dot')));
    });

    // FAQ accordion — one open at a time.
    $$('.alc-faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.alc-faq-item');
        var wasOpen = item.classList.contains('is-open');
        $$('.alc-faq-item').forEach(function (o) {
          o.classList.remove('is-open');
          o.querySelector('.alc-faq-q').setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Newsletter forms post natively to /contact on Shopify. Off Shopify we
    // fake the success state so the design still demos locally.
    $$('[data-alc="newsletter"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        // Before the early return below: on Shopify this is a real page POST,
        // so this handler's last act has to be recording that they joined.
        settleList();
        if (onShopify()) return;
        e.preventDefault();
        var b = form.querySelector('button[type="submit"]');
        if (b) b.textContent = form.getAttribute('data-sent-label') || 'You’re on the list ✦';
        var input = form.querySelector('input[type="email"]');
        if (input) input.value = '';
      });
    });

    // Phone dropdown menu.
    var burger = $('[data-alc="burger"]');
    var menu = $('[data-alc="menu"]');
    function setMenu(open) {
      if (!burger || !menu) return;
      menu.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (burger && menu) {
      burger.addEventListener('click', function (e) {
        e.stopPropagation();
        setMenu(!menu.classList.contains('is-open'));
      });
      // Tapping a link should scroll to the section, not leave the panel
      // sitting over the thing you just asked to see.
      menu.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('a')) setMenu(false);
      });
      document.addEventListener('click', function (e) {
        if (!menu.contains(e.target) && !burger.contains(e.target)) setMenu(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') setMenu(false);
      });
    }

    window.addEventListener('scroll', updateNavInk, { passive: true });
    window.addEventListener('resize', function () {
      updateNavInk();
      measureIndicator();
      carMeasure();
      markCurrentCard();
      // The reserved hero height belongs to one screen width. Rotating or
      // resizing invalidates it, so throw it away and measure again.
      heroMinH = 0;
      stabiliseHero();
      // Rotating to landscape can cross the breakpoint; a menu left open would
      // then hang under a nav bar that no longer has a button to close it.
      if (window.innerWidth > 640) setMenu(false);
    });

    /* Re-scramble on a slow tick so the encrypted text looks alive rather than
       like a static string of symbols. Runs for the four unreleased flavours,
       and for Glow too when either Glow toggle has put its formula behind the
       cipher — otherwise Glow's text would scramble once on render and then sit
       frozen while every other flavour shimmered. */
    timers.crypt = setInterval(function () {
      if (active === 'glow' && !cfg.glowCrypt && !cfg.glowFullLock) return;
      var p = PRODUCTS[active];
      $('[data-alc="long-desc"]').textContent = scramble(p.longDesc);
      $('[data-alc="nutrition"]').innerHTML = nutritionHtml(p, true);
      /* Replacing the cards wholesale has two side effects that the visitor
         feels directly, because this runs every 620ms:

         - scrollLeft resets to 0, so a locked flavour's carousel snapped back
           to the first card while you were still swiping it;
         - the class marking the card you are looking at is destroyed, which
           on a phone drops it back to the dimmed, scaled-down state.

         Save the position, rewrite, put both back. */
      var car = $('[data-alc="carousel"]');
      var at = car ? car.scrollLeft : 0;
      car.innerHTML = ingredientsHtml(p, true);
      if (at) {
        var prevBehavior = car.style.scrollBehavior;
        car.style.scrollBehavior = 'auto';   // a restore must not animate
        car.scrollLeft = at;
        car.style.scrollBehavior = prevBehavior;
      }
      markCurrentCard();
    }, 620);

    applyTheme(active);
    render();
    watchBottle();
    syncCart();

    // Shopify's customer form is a real page POST, so a successful signup comes
    // back as a fresh page load with ?customer_posted=true. Without this the
    // shopper would just see the page reset and wonder if it worked.
    if (/[?&]customer_posted=true/.test(window.location.search)) {
      settleList();   // they arrived here by signing up; don't ask them again
      setTimeout(function () { showBubble('✦ You’re on the list', 3200); }, 900);
    }
    scheduleStar();
    startSplash();
    enableEffects();
    setTimeout(measureIndicator, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
